import { SectionLayout } from "@/components/marketing/SectionLayout";
import { Link } from "@tanstack/react-router";
import { SectionHeader } from "@/components/marketing/primitives";
import type { CrossLink } from "@/content/crosslinks";

export function CrossLinks({
  items,
  num,
  title,
}: {
  items: CrossLink[];
  num: string;
  title: React.ReactNode;
}) {
  if (!items?.length) return null;
  return (
    <section className="bhg-section">
      <SectionLayout>
        <SectionHeader num={num} title={title} />
        <ul
          className="mt-10 list-none p-0"
        >
          {items.map((l) => (
            <li
              key={l.to}
              style={{
                padding: "20px 0",
                borderBottom: "1px solid rgba(0,47,167,0.12)",
              }}
            >
              <Link
                to={l.to}
                style={{
                  fontFamily: '"IBM Plex Sans", "IBM Plex Sans Fallback", sans-serif',
                  fontWeight: 400,
                  fontSize: "clamp(17px, 1.6vw, 20px)",
                  color: "#002FA7",
                  textDecoration: "underline",
                  textUnderlineOffset: "4px",
                }}
              >
                {l.label}
              </Link>
              <p
                className="mt-2"
                style={{
                  margin: 0,
                  color: "rgba(0,47,167,0.74)",
                  fontSize: 15,
                  lineHeight: 1.55,
                  maxWidth: "62ch",
                }}
              >
                {l.note}
              </p>
            </li>
          ))}
        </ul>
      </SectionLayout>
    </section>
  );
}
